/**
 * The subscription journeys' icon set: the app's HugeIcons family at stroke
 * 1.8, named after the design reference `icons.js` keys. Decorative by default;
 * label the enclosing control. `JourneyIcon name="chevron"` / `"back"` mirror
 * under native RTL, everything else never flips.
 */
import {
  AlertCircleIcon,
  AppleIcon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  BellIcon,
  BugIcon,
  Calendar03Icon,
  Cancel01Icon,
  CheckmarkCircle02Icon,
  Clock01Icon,
  Copy01Icon,
  CreditCardIcon,
  GaugeIcon,
  ExternalLinkIcon,
  File01Icon,
  HelpCircleIcon,
  InformationCircleIcon,
  Link01Icon,
  LockIcon,
  MoreHorizontalIcon,
  PauseIcon,
  PlayStoreIcon,
  RefreshIcon,
  SecurityCheckIcon,
  Settings01Icon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  Tick02Icon,
  Wallet01Icon,
  Wifi01Icon,
  BriefcaseBusinessIcon,
} from '@hugeicons/core-free-icons';
import { HugeIcon, type HugeIconData } from '../icons/HugeIcon';
import { flipForRTL } from './journey-theme';

const ICONS = {
  apple: AppleIcon,
  back: ArrowLeft01Icon,
  bell: BellIcon,
  briefcase: BriefcaseBusinessIcon,
  bug: BugIcon,
  calendar: Calendar03Icon,
  card: CreditCardIcon,
  check: Tick02Icon,
  checkCircle: CheckmarkCircle02Icon,
  chevron: ArrowRight01Icon,
  clock: Clock01Icon,
  close: Cancel01Icon,
  copy: Copy01Icon,
  document: File01Icon,
  ellipsis: MoreHorizontalIcon,
  usage: GaugeIcon,
  external: ExternalLinkIcon,
  help: HelpCircleIcon,
  info: InformationCircleIcon,
  link: Link01Icon,
  lock: LockIcon,
  pause: PauseIcon,
  play: PlayStoreIcon,
  refresh: RefreshIcon,
  settings: Settings01Icon,
  shield: SecurityCheckIcon,
  thumbDown: ThumbsDownIcon,
  thumbUp: ThumbsUpIcon,
  wallet: Wallet01Icon,
  warning: AlertCircleIcon,
  wifi: Wifi01Icon,
} satisfies Record<string, HugeIconData>;

export type JourneyIconName = keyof typeof ICONS;

const DIRECTIONAL: ReadonlySet<JourneyIconName> = new Set(['chevron', 'back']);

export function JourneyIcon({
  name,
  size = 20,
  color,
  strokeWidth = 1.8,
}: {
  name: JourneyIconName;
  size?: number;
  color: string;
  strokeWidth?: number;
}) {
  return (
    <HugeIcon
      icon={ICONS[name]}
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      style={DIRECTIONAL.has(name) ? flipForRTL : undefined}
    />
  );
}
